import { render } from "./JuRuPage.vue?vue&type=template&id=da7592dc&scoped=true"
import script from "./JuRuPage.vue?vue&type=script&lang=js"
export * from "./JuRuPage.vue?vue&type=script&lang=js"

import "./JuRuPage.vue?vue&type=style&index=0&id=da7592dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da7592dc"]])

export default __exports__